import * as Msdyn365 from '@msdyn365-commerce/core';
import { trackedAction } from '../../utilities/track-execution-time';

export class SubmitProductRequestInput implements Msdyn365.IActionInput {
    public formInput: IProductRequestFormInput;

    constructor(formInput: IProductRequestFormInput) {
        this.formInput = formInput;
    }

    public getCacheKey = () => `SubmitProductRequest-${new Date().getTime()}`;
    public getCacheObjectType = () => 'SubmitProductRequest';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IProductRequestFormInput {
    FirstName: string;
    LastName: string;
    Email: string;
    Company: string;
    Country: string;
    Phone: string;
    TargetCompound: string;
    RequiredQty: string;
    DeliveryDate: string;
    TargetPrice: string;
    AdditionalInformation: string;
    Language: string;
}

export interface ISubmitProductRequestResponseData {
    '@odata.context'?: string;
    Success?: boolean;
    Message?: string;
}

export interface ISubmitProductRequestData {
    result: ISubmitProductRequestResponseData;
    error?: { errorCode: number; errorText: string };
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new SubmitProductRequestInput({} as IProductRequestFormInput);
};

async function action(input: SubmitProductRequestInput, ctx: Msdyn365.IActionContext): Promise<ISubmitProductRequestResponseData> {
    let responseData: ISubmitProductRequestResponseData = {};

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SubmitCustomProductRequest`,
        'post',
        {
            formInput: input.formInput
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                ...(ctx.requestContext.user?.token && { Authorization: `id_token ${ctx.requestContext.user.token}` })
            }
        }
    )
        .then(res => {
            responseData = res.data as ISubmitProductRequestResponseData;
        })
        .catch(error => {
            console.error('Error submitting product request', error);
            throw new Error('Error submitting product request');
        });

    return responseData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISubmitProductRequestResponseData>>(
        ((input, ctx) => trackedAction(action, input, ctx, 'SubmitProductRequest'))
    ),
    id: 'SubmitProductRequest',
    input: createInput
});
